var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 220,
  height: 96,
  viewBox: "0 0 220 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#yellow_svg__clip0_4438_2169)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 220,
  height: 96,
  fill: "#FDA700"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow_svg__filter0_i_4438_2169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M230 168V-72L110 48L230 168Z",
  fill: "#FDA700"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow_svg__filter1_i_4438_2169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M270 168V-72L150 48L270 168Z",
  fill: "#FDA700"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow_svg__filter2_i_4438_2169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M310 168V-72L190 48L310 168Z",
  fill: "#FDA700"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow_svg__filter3_i_4438_2169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-10 168L-10 -72L110 48L-10 168Z",
  fill: "#FDA700"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow_svg__filter4_i_4438_2169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-50 168L-50 -72L70 48L-50 168Z",
  fill: "#FDA700"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow_svg__filter5_i_4438_2169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-90 168L-90 -72L30 48L-90 168Z",
  fill: "#FDA700"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "yellow_svg__filter0_i_4438_2169",
  x: 110,
  y: -72,
  width: 124,
  height: 240,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9625 0 0 0 0 0.593542 0 0 0 0 0.0401042 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4438_2169"
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow_svg__filter1_i_4438_2169",
  x: 150,
  y: -72,
  width: 124,
  height: 240,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9625 0 0 0 0 0.593542 0 0 0 0 0.0401042 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4438_2169"
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow_svg__filter2_i_4438_2169",
  x: 190,
  y: -72,
  width: 124,
  height: 240,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9625 0 0 0 0 0.593542 0 0 0 0 0.0401042 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4438_2169"
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow_svg__filter3_i_4438_2169",
  x: -14,
  y: -72,
  width: 124,
  height: 240,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9625 0 0 0 0 0.593542 0 0 0 0 0.0401042 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4438_2169"
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow_svg__filter4_i_4438_2169",
  x: -54,
  y: -72,
  width: 124,
  height: 240,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9625 0 0 0 0 0.593542 0 0 0 0 0.0401042 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4438_2169"
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow_svg__filter5_i_4438_2169",
  x: -94,
  y: -72,
  width: 124,
  height: 240,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9625 0 0 0 0 0.593542 0 0 0 0 0.0401042 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4438_2169"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "yellow_svg__clip0_4438_2169"
}, /*#__PURE__*/React.createElement("rect", {
  width: 220,
  height: 96,
  fill: "white"
})))));
export { SvgYellow as ReactComponent };
export default __webpack_public_path__ + "assets/icons/yellow.939c8f.svg";